import BlocksSubHeader from "../../../components/Blocks/BlocksSubHeader";
import BrandsBlock from "../../../components/BrandBlock/BrandBlocks";
import Header from "../../../components/Header/Header";
import SideNavbar from "../../../components/Navbar/SideNavbar";

const BrandBlocks = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <BlocksSubHeader />
                        <BrandsBlock />
                    </div>
                </div>
            </div>
        </>
    )
}
export default BrandBlocks